import React, { Fragment } from "react";
import "./breadCrumb.scss";

const BreadCrumb = ({ type, community, province, onClick }) => {
  const onClickHandler = item => {
    if (onClick) {
      onClick(item);
    }
  };
  return (
    <Fragment>
      <div className="breadCrumb">
        <ul className="breadCrumb_content">
          {type && (
            <li className="breadCrumb_item_container breadCrumb_item_type">
              <div className="breadCrumb_item">
                <span className="breadCrumb_item_content">
                  <span className="truncate" onClick={() => onClickHandler()}>
                    {type}
                  </span>
                </span>
              </div>
            </li>
          )}
          {community && community.typePlace !== "COUNTRY" && (
            <li
              className="breadCrumb_item_container breadCrumb_item_community"
              onClick={() => onClickHandler(community)}
            >
              <div className="breadCrumb_item">
                <span className="breadCrumb_item_content">
                  <span className="truncate">{community.name}</span>
                </span>
              </div>
            </li>
          )}
          {province && (
            <li
              className="breadCrumb_item_container breadCrumb_item_province"
              onClick={() => onClickHandler(province)}
            >
              <div className="breadCrumb_item">
                <span className="breadCrumb_item_content">
                  <span className="truncate">{province.name}</span>
                </span>
              </div>
            </li>
          )}
        </ul>
      </div>
    </Fragment>
  );
};

export default BreadCrumb;
